import { render } from "./invite-others-banner.vue?vue&type=template&id=8654fc40&lang=pug"
import script from "./invite-others-banner.vue?vue&type=script&lang=js"
export * from "./invite-others-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__